// extracted by mini-css-extract-plugin
export var form = "signup-module--form--ac681";
export var inputCtrl = "signup-module--inputCtrl--25dcb";
export var lineTitle = "signup-module--lineTitle--c0518";
export var providerBtn = "signup-module--providerBtn--fef80";
export var section = "signup-module--section--7fd55";
export var signBtn = "signup-module--signBtn--7daaf";
export var title = "signup-module--title--eacb0";